// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Activity(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Activity" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5918 1.16406L16.7765 15.6305L18.951 11.5118H22.5V13.9873H20.549L16.2235 22.7091L12.4081 9.5191L9.93119 16.8587L6.46812 12.2979L5.09983 13.9873H1.5V11.5118H3.90012L6.53182 8.26255L9.06875 11.6036L12.5918 1.16406Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Activity.js.map